import {type VariantProps} from 'class-variance-authority';
import {Slot} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {buttonVariants} from './button-variants';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({className, variant, size, asChild = false, children, ...props}, ref) => {
    if (asChild) {
      return (
        <Slot.Slot
          className={cn(buttonVariants({variant, size}), className)}
          ref={ref}
          {...props}
        >
          {children}
        </Slot.Slot>
      );
    }

    return (
      <button
        className={cn(buttonVariants({variant, size}), className)}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = 'Button';

export {Button};
